module.exports = __webpack_public_path__ + "static/GochiHand-Regular-9b48452cfcc1da9b1f684f991cb3d1e3.ttf";